import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-186acb03"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  class: "top"
};
const _hoisted_4 = {
  class: "head"
};
const _hoisted_5 = {
  class: "store-name"
};
const _hoisted_6 = {
  class: "address"
};
const _hoisted_7 = {
  class: "code"
};
const _hoisted_8 = {
  style: {
    "padding-top": "0.2rem",
    "background": "#ffffff",
    "border-radius": "0.2rem 0.2rem 0.2rem 0.2rem"
  }
};
const _hoisted_9 = {
  style: {
    "height": "0.28rem",
    "margin-right": "0.05rem"
  }
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "上一页", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "下一页", -1));
const _hoisted_12 = {
  style: {
    "height": "0.28rem",
    "margin-left": "0.05rem"
  }
};
const _hoisted_13 = {
  key: 1,
  class: "content"
};
const _hoisted_14 = {
  class: "contentheader"
};
const _hoisted_15 = {
  key: 0,
  style: {
    "color": "red"
  }
};
const _hoisted_16 = {
  class: "content-box-title"
};
const _hoisted_17 = {
  key: 0,
  class: "content-box-in"
};
const _hoisted_18 = {
  key: 1,
  class: "content-box-anter content-box-in"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "答：", -1));
const _hoisted_20 = {
  key: 2,
  class: "content-box-in"
};
const _hoisted_21 = {
  class: "content-box-in-img"
};
const _hoisted_22 = {
  class: "content-box-img"
};
const _hoisted_23 = ["onClick"];
const _hoisted_24 = {
  key: 3,
  style: {
    "text-align": "right",
    "display": "flex",
    "align-items": "center",
    "justify-content": "right",
    "color": "#5a80b0",
    "margin-top": "0.12rem"
  }
};
const _hoisted_25 = ["onClick"];
const _hoisted_26 = {
  class: "footid"
};
const _hoisted_27 = {
  key: 0
};
const _hoisted_28 = {
  key: 1
};
const _hoisted_29 = {
  class: "bottombtn"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_pagination = _resolveComponent("van-pagination");
  const _component_van_tab = _resolveComponent("van-tab");
  const _component_van_tabs = _resolveComponent("van-tabs");
  const _component_van_empty = _resolveComponent("van-empty");
  const _directive_lazy = _resolveDirective("lazy");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$data.projectdate.orgTerminalName ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [$data.type1 === 'NEW' ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass([_ctx.status1 === 'CANCELLED' ? 'over' : 'new', "new"])
  }, "新", 2)) : _createCommentVNode("", true), $data.type1 !== 'NEW' ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass(_ctx.status1 === 'CANCELLED' ? 'over' : 'notnew')
  }, null, 2)) : _createCommentVNode("", true), _createElementVNode("div", null, _toDisplayString($data.projectdate.orgTerminalName), 1)])]), _createElementVNode("div", _hoisted_6, _toDisplayString($data.projectdate.province) + _toDisplayString($data.projectdate.city) + _toDisplayString($data.projectdate.district), 1), _createElementVNode("div", _hoisted_7, "任务：" + _toDisplayString($data.projectdate.positionName), 1)]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_van_tabs, {
    active: $data.active,
    "onUpdate:active": _cache[1] || (_cache[1] = $event => $data.active = $event),
    "title-active-color": "#3875C6",
    "title-inactive-color": "#666",
    "line-width": "2rem",
    color: "#3875C6",
    "before-change": $options.changeactive,
    class: "custom-tabs"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.projectdate.data, item => {
      return _openBlock(), _createBlock(_component_van_tab, {
        key: item,
        title: `${item.taskName}（${item.taskCount}）`
      }, {
        default: _withCtx(() => [$data.projectdatelist.length !== 1 ? (_openBlock(), _createBlock(_component_van_pagination, {
          key: 0,
          modelValue: $data.currentPage,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.currentPage = $event),
          "page-count": $data.projectdatelist.length,
          mode: "simple",
          onChange: $options.changepage
        }, {
          "prev-text": _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createVNode(_component_van_icon, {
            name: "arrow-left"
          })]), _hoisted_10]),
          "next-text": _withCtx(() => [_hoisted_11, _createElementVNode("div", _hoisted_12, [_createVNode(_component_van_icon, {
            name: "arrow"
          })])]),
          _: 1
        }, 8, ["modelValue", "page-count", "onChange"])) : _createCommentVNode("", true), $data.projectdatelist.length ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_14, [_createTextVNode(_toDisplayString($data.projectdatelist[$data.currentPage - 1].subTaskTitle) + " ", 1), $data.projectdatelist[$data.currentPage - 1].needFaceCompare ? (_openBlock(), _createElementBlock("span", _hoisted_15, "[人像识别]")) : _createCommentVNode("", true)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.projectdatelist[$data.currentPage - 1].data, (item1, index1) => {
          return _openBlock(), _createElementBlock("div", {
            class: "contentbox",
            key: item1
          }, [_createElementVNode("div", _hoisted_16, _toDisplayString(index1 + 1) + "、" + _toDisplayString(item1.question), 1), item1.itemType === 1 || item1.itemType === 0 || item1.itemType === 5 ? (_openBlock(), _createElementBlock("div", _hoisted_17, " 答：" + _toDisplayString(item1.answer[0]), 1)) : _createCommentVNode("", true), item1.itemType === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_hoisted_19, _createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item1.answer, (item2, index2) => {
            return _openBlock(), _createElementBlock("div", {
              key: item2
            }, [_createElementVNode("div", null, _toDisplayString(index2 + 1) + "、" + _toDisplayString(item2), 1)]);
          }), 128))])])) : _createCommentVNode("", true), item1.itemType === 3 ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item1.answer, img => {
            return _withDirectives((_openBlock(), _createElementBlock("img", {
              key: img,
              alt: "",
              class: "img",
              onClick: $event => $options.preview(img)
            }, null, 8, _hoisted_23)), [[_directive_lazy, img]]);
          }), 128))])])])) : _createCommentVNode("", true), item1.itemType === 3 ? (_openBlock(), _createElementBlock("div", _hoisted_24, [item1.exampleImg ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onClick: $event => $options.preview(item1.exampleImg)
          }, "查看示例", 8, _hoisted_25)) : _createCommentVNode("", true), item1.exampleImg ? (_openBlock(), _createBlock(_component_van_icon, {
            key: 1,
            name: "arrow"
          })) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]);
        }), 128)), _createElementVNode("div", _hoisted_26, [_createElementVNode("div", null, "触点姓名：" + _toDisplayString($data.projectdatelist[$data.currentPage - 1].userName), 1), _createElementVNode("div", null, "提交时间：" + _toDisplayString($data.projectdatelist[$data.currentPage - 1].reportTime), 1), $data.projectdatelist[$data.currentPage - 1].auditorName ? (_openBlock(), _createElementBlock("div", _hoisted_27, " 审 核 人：" + _toDisplayString($data.projectdatelist[$data.currentPage - 1].auditorName), 1)) : _createCommentVNode("", true), $data.projectdatelist[$data.currentPage - 1].auditTime ? (_openBlock(), _createElementBlock("div", _hoisted_28, " 审核时间：" + _toDisplayString($data.projectdatelist[$data.currentPage - 1].auditTime), 1)) : _createCommentVNode("", true)])])])) : _createCommentVNode("", true)]),
        _: 2
      }, 1032, ["title"]);
    }), 128))]),
    _: 1
  }, 8, ["active", "before-change"])])])) : (_openBlock(), _createBlock(_component_van_empty, {
    key: 1,
    description: $data.success ? '当前暂无可查看的任务执行内容！' : '暂无数据'
  }, null, 8, ["description"])), _createElementVNode("div", _hoisted_29, [$data.activeName ? (_openBlock(), _createElementBlock("button", {
    key: 0,
    class: "btn1",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.goback1 && $options.goback1(...args))
  }, "返回")) : (_openBlock(), _createElementBlock("button", {
    key: 1,
    class: "btn1",
    onClick: _cache[3] || (_cache[3] = (...args) => $options.goback2 && $options.goback2(...args))
  }, "返回"))])]);
}